export const ROUTES = {
  ROOT: "/",
  HOME: "/home",
  TEAMWORK: "/TeamWork",
  OFERTA: "/Oferta",
  CONTACTO: "/Contacto",
};

export const ANCLAS = {
  MAPA: "https://goo.gl/maps/FRwXTCRgxkHpkash6",
  SERVICIOS: "/#servicios",
  EQUIPOS: "/#equipos",
};
